import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';

function ExternalAdvertControl({
    mode,
    user,
    history,
    ...props
}) {

    useEffect(() => {
    
    }, [])


    return (

        <div className="ad-container">
            <h4>More Inside!</h4>
            <p>
                Want to save, copy, extend or share this route?
            </p>
            <p>
                Sign up to JustGoRide for free and start
                creating your own library of routes! 
            </p>
            <div className="">
                <Link to="/signup" className="btn btn-info">Sign Up</Link>
            </div>
        </div>
    );
}

ExternalAdvertControl.propTypes =
{
    mode: PropTypes.string,
    user: PropTypes.object
}


function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExternalAdvertControl)); 


// WEBPACK FOOTER //
// ./src/components/common/ExternalAdvertControl.js